export default {"src":"/_next/static/media/lightroom.3238a8d1.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};